import type { DriveStep } from 'driver.js';

export const adminApplicationsTourId = 'admin:applications';

export const adminApplicationsSteps: DriveStep[] = [
  {
    element: '[data-tour="admin:applications-list"]',
    popover: {
      title: 'Заявки',
      description:
        'Заявки на открытие новых пунктов выдачи. Каждая заявка содержит данные заявителя и информацию о будущем ПВЗ.',
    },
  },
  {
    element: '[data-tour="admin:help-btn"]',
    popover: {
      title: 'Помощь',
      description:
        'Помощь.',
    },
  },
];
